//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
Use Date picker 
*/
import {
    DatePicker as ReactDatePicker,//Date Picker control
    DatePickerInput, //For Date Input
    DatePickerCalendar,//To Show Calender control
    DatePickerButton,//To show next previous button
    DatePickerMonth,//To show month on calender control
    DatePickerTable //To show dates in table structure
} from '@reecelucas/react-datepicker';
import { parse, format } from 'date-fns';
//#endregion


/**
* Used in Planner>>PlannerOptions
*/
class DatePicker extends React.Component {
    render() {
        return(
            <ReactDatePicker className="otp-datepicker"
                onSelect={selection => this.props.handleInput({target: {name: 'date', value: format(selection, 'MM/DD/YYYY')}})}
                initialDate={parse(this.props.value, 'MM/DD/YYYY')}
            >
                <DatePickerInput
                    className="dp-input"
                    name="date"
                    id="date"
                    dateFormat={'MM/dd/yyyy'}
                />

                <DatePickerCalendar className="dp-calendar">
                    <div className="dp-top-bar">
                        <DatePickerButton
                            className="dp-button"
                            aria-label="Go to previous month."
                            updateMonth={({ prev }) => prev()}
                        >
                            <svg focusable="false" viewBox="0 0 1000 1000" aria-hidden="true">
                                <path d="M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z" />
                            </svg>
                        </DatePickerButton>
                        <DatePickerMonth className="dp-month" />
                        <DatePickerButton
                            className="dp-button"
                            aria-label="Go to next month."
                            updateMonth={({ next }) => next()}
                        >
                            <svg focusable="false" viewBox="0 0 1000 1000" aria-hidden="true">
                                <path d="M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z" />
                            </svg>
                        </DatePickerButton>
                    </div>
                    <DatePickerTable className="dp-table" />
                </DatePickerCalendar>
            </ReactDatePicker>
        );
    }
}

export default DatePicker;